// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3F8np","selector":"Card_selector__1oqJF","verticalcenter":"Card_verticalcenter__2WfLg"};